export default "__VITE_ASSET__CUSnIcF2__"